import { notification } from 'amumu-ui/src/factory'

const LIMIT_NUMBER = 3
const NOTIFICATION_PARAMS = {
  duration: 0,
  position: 'bottom-right',
  messageIsHtml: true,
}
const notificationList: any[] = []

const set = (type: any, notification: any) => {
  notificationList.push({ type, notification })
}

const destroy = () => {
  if (notificationList.length > LIMIT_NUMBER) {
    const firstItem = notificationList[0]
    removeNotification(firstItem.type)
  }
}

export enum NotificationType {
  newMail,
  workflow,
  archiveAdvice,
  opportunityAutomation,
  mailTodoRemind,
  newAliMessage,
  leadAutoCreate,
  newAliOrder,
  newMKTLiveChatMessage,
  newMKTLiveChatVisitor,
  sendMailFail,
  aliStoreWillExpire,
  aliStoreExpired,
  purchaseProductTransfer,
  newCustomerCount,
  createProductTransfer,
  changeHandlerProductTransfer,
  removeProductTransfer,
  changeStatusProductTransfer,
  changeContentProductTransfer,
  changeProgressProductTransfer,
  upstreamInvoiceProductTransfer,
  waitHandlerProductTransfer,
  commentProductTransfer,
  paymentInvoice,
  facebookPageExpire,
  facebookPageAssign,
  facebookPageRemoveAssign,
  facebookComment,
  facebookMessenger,
  erpServiceAuthSuccess,
  erpServiceAuthFailed,
  erpServiceSyncFinish,
}

export const removeNotification = (type: any) => {
  const index = notificationList.findIndex(item => item.type === type)
  if (~index) {
    const notification = notificationList[index].notification
    notificationList.splice(index, 1)
    notification.destroy(true)
  }
}

export const createNotification = (type: any, options: any) => {
  removeNotification(type)
  const notificationInfo = notification({ ...NOTIFICATION_PARAMS, ...options })
  set(type, notificationInfo)
  destroy()
}
